

































































import IAnswer from '@/models/IAnswer'
import { TranslateResult } from 'vue-i18n'

import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component({
  name: 'c-question-create-dialog'
})
export default class QuestionCreateDialog extends Vue {
  // Props
  @Prop({
    type: Object,
    default: null
  })
  editedAnswer!: IAnswer

  @Prop()
  currentTitle!: string

  // Data
  protected TYPE_TEXT = this.$t('survey.types.typeText')
  protected TYPE_SELECT = this.$t('survey.types.typeSelect')
  protected SPECIFY_SINGLE = this.$t('survey.types.specifySingle')
  protected SPECIFY_MULTI = this.$t('survey.types.specifyMulti')

  title: string = ''
  typeList = [this.TYPE_TEXT, this.TYPE_SELECT]
  type: TranslateResult = this.TYPE_SELECT
  specifyList: TranslateResult[] = [this.SPECIFY_SINGLE, this.SPECIFY_MULTI]
  specify: TranslateResult = this.SPECIFY_SINGLE

  // Emit
  @Emit()
  close (): void {}

  @Emit()
  submit () {
    return {
      title: this.title,
      type: this.type
    }
  }

  // Computed
  get isEdit (): boolean {
    return !!this.editedAnswer
  }

  get dialogTitle (): TranslateResult {
    if (this.isEdit) return this.$t('survey.createDialog.editQuestion')

    return this.$t('survey.createDialog.addQuestion')
  }

  // Methods
}
